import React from 'react';
import { TranslationFunction } from '../types';

interface StepNavigationProps {
  onNext: () => void;
  onPrevious: () => void;
  currentStep: number;
  totalSteps: number;
  onPrint?: () => void;
  onExportToExcel?: () => void;
  t: TranslationFunction;
}

export const StepNavigation: React.FC<StepNavigationProps> = ({ onNext, onPrevious, currentStep, totalSteps, onPrint, onExportToExcel, t }) => {
  return (
    <div className="mt-8 pt-6 border-t border-gray-300 flex justify-between items-center no-print">
      <button
        onClick={onPrevious}
        disabled={currentStep === 0}
        className="bg-gray-500 hover:bg-gray-600 text-white font-semibold py-2 px-6 rounded-md shadow-md transition duration-150 ease-in-out disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {t('previous')}
      </button>

      <div className="flex items-center space-x-4">
        {currentStep === totalSteps - 1 ? (
          <>
            {onExportToExcel && (
              <button
                onClick={onExportToExcel}
                className="bg-green-700 hover:bg-green-800 text-white font-semibold py-2 px-6 rounded-md shadow-md transition duration-150 ease-in-out"
              >
                {t('export_to_excel')}
              </button>
            )}
            {onPrint ? (
              <button
                onClick={onPrint}
                className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-6 rounded-md shadow-md transition duration-150 ease-in-out"
              >
                {t('download_pdf')}
              </button>
            ) : (
              <button
                className="bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-6 rounded-md shadow-md transition duration-150 ease-in-out"
              >
                {t('submit_return')}
              </button>
            )}
          </>
        ) : (
          <button
            onClick={onNext}
            className="bg-[#b98e4c] hover:bg-[#a37d40] text-[#1a2c46] font-semibold py-2 px-6 rounded-md shadow-md transition duration-150 ease-in-out"
          >
            {t('next')}
          </button>
        )}
      </div>
    </div>
  );
};
